import React from 'react'
import Header from '../../components/layout/Header/Header';
import Layout from '../../components/layout/Layout/Layout';
import { Products } from '../../components/global/Products/Products';
import { GetServerSideProps } from 'next';

export default function ProductsPage() {
  return (
    <Layout>
      <Header />
      <Products/>
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const asPath = req.url || '';

  if (asPath.includes("sale/completed")) {
    const destination =
      process.env.NODE_ENV === 'development'
        ? `${process.env.REACT_APP_API_URL}${asPath}`
        : `https://billing.${process.env.LEGACY_DOMAIN}${asPath}`;

    return {
      redirect: {
        destination,
        permanent: false,
      },
    };
  }

  return {
    props: {}, // Pass any props to the page component
  };
};
